import Token from './Token';

export const token = {
  list: Token,
};
